import { AfterContentInit, Component, Input, OnInit } from '@angular/core';
import {
  OPERATION, SupplierAddressPropertyValues, TabPermissions,
  SupplierEntityPropertyValues, SupplierAddress, SupplierDocumentPropertyValues,
  SupplierPropertyValue, Supplier, SupplierDocument, SupplierContactPropertyValue
} from 'app/profile/models/supplier.model';
import { MatDialog} from '@angular/material/dialog';
import { PageEvent} from '@angular/material/paginator';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SupplierState } from 'app/profile/store/state/supplierstate.state';
import { Store, select } from '@ngrx/store';
import {
  SelectSupplierAddressList, SelectCountries,
  SelectTabPermissions, SelectSupplierEntityList, SelectSupplierDocumentList, SelectSupplierMfgAddressList,
  getAvailableConfiguration, SelectSupplierWarehouseAddressList,
  SelectSupplierPickupWarehouseAddressList, SelectSupplierAddressTypes, SelectEventData, getSupplierExternalPartnerList, SelectValidationTask, SelectCurrentUser, SelectSupplierContactList, getGeneralSettings
} from 'app/profile/store/app.selector';
import { GetCountryList, GetSupplierAddressContactTypes, PostEvent } from 'app/profile/store/app.actions';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonService } from 'app/profile/services/common.service';
import { BehaviorSubject, Observable, combineLatest, forkJoin } from 'rxjs';
import { deepfind, GetFullAddress, getNestedNode, GetFullAddressDetails, GetCountryDetails } from 'app/shared/utils/utils';
import { Country, AddressType } from 'app/profile/models/masterdata.model';
import {
  GetSupplierAddressListByCode, GetTabPermissions,
  DeleteSupplierAddress, GetSupplierDocumentsListByCode, ClearSupplierDetailsByCode, GetSupplierMfgAddressListByCode,
  GetSupplierWarehouseAddressListByCode, AddWarehouseSupplierAddress, EditWarehouseSupplierAddress,
  DeleteWarehouseSupplierAddress, GetSupplierPickupWarehouseAddressListByCode, GetSupplierEntityListByCode, GetSupplierExernalPartnerList, GetValidationTaskByCode, GetSupplierProfileCurrentUser
} from 'app/profile/store/actions/supplierstate.action';
import { IncrementLoaderCount, DecrementLoaderCount } from 'app/shared/store/actions';
import { AddressSuggestionComponent } from 'app/shared/components/address-suggestion/address-suggestion.component';
import { SupplierStateService } from 'app/profile/services/supplierstate.service';
import { SupplierWarehouse, PickupWarehouse } from 'app/profile/models/profile.model';
import { ProfileService } from 'app/profile/services/profile.service';
import { TslDialog, TslTabChangeEvent } from '@tesla/ng-tds';
import { StatusEnum, Status } from 'app/profile/models/state.model';
import { StateService } from 'app/profile/services/state.service';
import { ValidationTask } from 'app/profile/models/people.model';
import { SupplierContactMap, UserDetails } from 'app/profile/models/user.model';
import { switchMap } from 'rxjs/operators';
import { BaseComponent } from 'app/profile/components/base.component';
import { I18nService } from 'app/shared/services/i18n.service';
import { AddressDialogComponent } from '../../address-grid/address-dialog/address-dialog.component';
import { TabHistoryComponent } from 'app/profile/components/tab-history/tab-history.component';

@Component({
  selector: 'app-manufacturing-address',
  templateUrl: './manufacturing-address.component.html',
  styleUrls: ['./manufacturing-address.component.scss']
})
export class ManufacturingAddressComponent extends BaseComponent implements OnInit, AfterContentInit {
  currentPageSource: BehaviorSubject<Array<any>> = new BehaviorSubject([]);
  SupplierCode: string;
  supplierAddressList: SupplierAddressPropertyValues[] = [];
  countryList: Country[];
  entityMap: SupplierEntityPropertyValues[];
  documentsList: SupplierDocumentPropertyValues[];
  obWarehouses$: SupplierWarehouse[];
  obPickupWarehouses$: PickupWarehouse[];
  addressData: (SupplierAddressPropertyValues | any)[] = [];

  tabPermissions: TabPermissions;
  availableFields: string[] = [];

  filterSelection = "Manufacturing";
  @Input() helpUrl: string="";

  addressModifiedSupplier: SupplierPropertyValue = new SupplierPropertyValue();
  files: File[] = [];
  // grid properties
  pageSizeOptions: number[] = [15, 25, 50, 100, 250];
  total = 0;
  displayedColumns = ["address", "comment", "documents", "actions"];
  addressPurpose: AddressType[] = [];
  validationTask: ValidationTask = null;
  hasDraftValidationTask: boolean = false;
  hasPendingValidationTask: boolean = false;
  primaryEmail: string = null;
  userDetails: UserDetails = null;
  defaultTabIndex: number = 0;
  code: string;
  externalPartners: any;
  pickuphouseAddressList;
  isPrimary: boolean = false;
  isProfileAdmin: boolean = false;
  showLinkDelink: boolean = false;
  contactEmails: string[] = [];
  settings: any;
  showManufacturingAddressCMTUrl: boolean;
  manufacturingAddresscmtUrl: any;
  constructor(private matDialog: MatDialog,
    private dialog: TslDialog,
    private store: Store<SupplierState>,
    private router: Router,
    private route: ActivatedRoute,
    private translateService: I18nService,
    private commonService: CommonService,
    private supplierStateService: SupplierStateService,
    private service: ProfileService,
    private stateService: StateService,
    private snackBar: MatSnackBar) {
    super();
  }

  ngAfterContentInit() {
    
  }

  ngOnInit() {
    this.store.dispatch(new GetSupplierProfileCurrentUser());

    combineLatest(
      [this.store.pipe(select(SelectCurrentUser)),
      this.route.parent.parent.params])
      .subscribe(([result, params]) => {
        if (params["code"]) {
          this.SupplierCode = this.commonService.getSupplierCode(params["code"]);
        }
        if (result) {
          this.userDetails = result;
        }

        if (this.SupplierCode && this.userDetails) {
          this.loadComponentData(true);
          this.store.select(getGeneralSettings).subscribe(res => {
            this.settings = res;
            if (res) {
                this.helpUrl = this.settings.settings.addressHelpUrl;
                this.showManufacturingAddressCMTUrl = this.settings.settings.showManufacturingAddressCMTUrl === "1";
                this.manufacturingAddresscmtUrl = this.settings.settings.manufacturingAddresscmtUrl;
            }
        });
        }
      });

  }
  
  loadComponentData(isReload: boolean = false) {
    if (this.SupplierCode !== null) {
      if (isReload) {
        this.store.dispatch(new ClearSupplierDetailsByCode(this.SupplierCode));
      }
      this.store.select((getAvailableConfiguration)).subscribe((result: string[]) => {
        this.availableFields = result;

        this.store.dispatch(new GetTabPermissions(this.SupplierCode, isReload));
        if (this.availableFields.includes("Add Address - Remit To")) {
          this.store.dispatch(new GetSupplierMfgAddressListByCode(this.SupplierCode));
        }

        this.store.pipe(select(SelectTabPermissions)).subscribe(tabPermissions => this.tabPermissions = tabPermissions);

        
        this.store.select(SelectSupplierMfgAddressList).subscribe((masterManufacturingAddresses: any[]) => {
            this.supplierAddressList = [];

            if (masterManufacturingAddresses && masterManufacturingAddresses.length > 0) {
              this.supplierAddressList.unshift(...masterManufacturingAddresses)
            }

            this.onLoadAddressGrouping();
          });
      });
    }
  }

  pageChange(pageChange: PageEvent) {
    const { previousPageIndex, pageSize, pageIndex } = pageChange;

    if (previousPageIndex === pageIndex) {
      this.currentPageSource.next(
        [...this.addressData].slice(0, pageSize)
      );
    } else {
      const from = pageIndex * pageSize;
      const to = from + pageSize;
      this.currentPageSource.next(
        [...this.addressData].slice(from, to)
      );
    }
  }

  loadData() {
    this.currentPageSource.next([...this.addressData].slice(0, 15));
    this.total = this.addressData.length;
  }

  getFullAddress(address: SupplierAddressPropertyValues) {
    if (address) {
      return GetFullAddress(address, 'newValue');
    }
  }

  getFullAddressDetails(address: SupplierAddressPropertyValues) {
    if (address) {
      return GetFullAddressDetails(address, 'newValue');
    }
  }

  getCountryDetails(address: SupplierAddressPropertyValues) {
    if (address) {
      return GetCountryDetails(address, 'newValue', this.countryList);
    }
  }

  onClearFilter() {
    this.filterSelection = "";
    this.loadData();
  }

  isAddressHeader(index, item): boolean {
    // returns if row item is a header
    return item.isGroup;
  }

  checkIfContactAlreadyExists(contactEmail: string): Boolean {
    if (contactEmail) {
      contactEmail = contactEmail.trim();
    }
    return this.contactEmails.some(x => x == contactEmail);
  }

  private onLoadAddressGrouping(): void {
    if (this.supplierAddressList && this.supplierAddressList.length > 0) {
      this.addressData = [];
      if (this.supplierAddressList && this.supplierAddressList.filter(d => d.types.newValue[0] === 'Manufacturing').length > 0) {
        this.addressData = this.addressData.concat(this.supplierAddressList.filter(d => d.types.newValue[0] === 'Manufacturing'));
      }

      this.loadData();
    }
  }

  showHistory() {
    const dialogRef = this.matDialog.open(TabHistoryComponent, {
      width: '90%',
      minWidth: '630px',
      maxHeight: '800px',
      data: { supplierCode: this.SupplierCode, tabName: 'Address' }
    });
  }
}


